import Styles from './badgesharing.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Module Imports.
import html2canvas from 'html2canvas';
import axios from 'axios';

// Components import
import { useAPI } from 'components/lib';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

// Assets Import.
import Bronze from 'assets/icons/trophy1.png';
import Silver from 'assets/icons/trophy2.png';
import Gold from 'assets/icons/trophy3.png';
import tgtlogo from 'assets/icons/tgtlogo.png';

export function BadgeSharing(props) {
	const navigate = useNavigate();
	const badgeRef = useRef(null);
	const { c_quiz_id } = useParams();
	const { data, loading } = useAPI(`/api/c_quiz/${c_quiz_id}/badge`, 'GET');

	const [accessToken, setAccessToken] = useState('');
	const [selectedImage, setSelectedImage] = useState(null);
	const [badgeDetails, setBadgeDetails] = useState('');
	const [showConfirm, setShowConfirm] = useState(false);

	//headers for linkedin api
	const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
	const redirectUri = process.env.REACT_APP_LINKEDIN_REDIRECT_URL + `/${c_quiz_id}/userBadge`;
	const scope = process.env.REACT_APP_LINKEDIN_SCOPE;

	//auth api to get the authorization code
	const authorizationUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;

	//get the authorization code from the url
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const code = urlParams.get('code');
		if (code) {
			setAccessToken(code);
		} else {
			window.location.href = authorizationUrl;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	//assign the data to the badgeDetails
	useEffect(() => {
		if (data) {
			setBadgeDetails(data);
		}
	}, [data]);

	async function convertPng() {
		//convert html to png (base64 format)
		await html2canvas(badgeRef.current)
			.then((canvas) => {
				const badgeUrl = canvas.toDataURL('image/png');
				setSelectedImage(badgeUrl);

			})
			.catch((err) => { });
	}

	convertPng(); //convert the html to png format while calling the function

	const goback = () => {
		navigate('/quiz');
	};

	//show the confirmation card
	function getConformation() {
		setShowConfirm(true);
	}

	const Event = require('components/lib').Event;


	// to post the post in the linkedIn
	const handlePostToLinkedIn = async () => {
		try {
			const Image = { image: selectedImage.toString(), techname: badgeDetails?.tech };
			const options = {
				method: 'POST',
				url: `/api/c_quiz/${c_quiz_id}/badge`,
				headers: {
					authorization: `${accessToken}`,
				},
				data: Image,
			};
			await axios
				.request(options)
				.then((response) => {
					alert(props.t('CommonQuiz.BadgeSharing.alert.success'));
					Event('badge_shares')
					goback();
				})
				.catch((err) => {
					alert(props.t('CommonQuiz.BadgeSharing.alert.failed'));
					goback();
				});
		} catch (error) {
			console.error('Error posting image to LinkedIn:', error);
		}
	};

	return (
		<>
			{showConfirm && (
				<ConfirmationCard
					title={props.t('CommonQuiz.BadgeSharing.confirm.title')}
					body={props.t('CommonQuiz.BadgeSharing.confirm.descr')}
					showCard={showConfirm}
					setShowCard={setShowConfirm}
					handleCancel={goback}
					handleConfirm={handlePostToLinkedIn}
				/>
			)}
			{loading ? (
				<LoadingBackdrop isOpen={true} />
			) : (
				<div>
					{accessToken ? (
						<div className={Styles.container}>
							<div ref={badgeRef} className={Styles.badgecontainer} style={{ height: '390px', width: '300px' }}>
								<img className={Styles.tgtlogo} src={tgtlogo} alt="Logo" />
								<img
									src={badgeDetails.badge === 'Gold' ? Gold : badgeDetails.badge === 'Silver' ? Silver : Bronze}
									alt="Generated Badge"
									className={Styles.badge_image}
								/>
								<p>You have successfully earned</p>
								<p>
									{badgeDetails.badge} in {badgeDetails.tech} quiz
								</p>
								<p>Level - {badgeDetails.level}</p>
							</div>
							<div className={Styles.buttonContainer}>
								<button
									className={Styles.postbutton}
									variant="contained"
									style={{ backgroundColor: '#008037', borderRadius: '45px' }}
									onClick={getConformation}
								>
									{props.t('CommonQuiz.BadgeSharing.button')}
								</button>
							</div>
						</div>
					) : (
						<></>
					)}
				</div>
			)}
		</>
	);
};